export default {
  common: {
    done: 'Feito',
    term: 'Prazo',
    year: 'Ano | Anos',
    years: 'Anos',
    yr: '/ano',
    month: 'Mês | Meses',
    quantity: 'Quantidade',
    add: 'Adicionar',
    loading: 'Carregando',
    error: "Por favor, corrija os erros ou <a  class='link-info'>remova</a> o item do seu carrinho.",
    domain: 'Domínio',
    edit: 'Editar',
    account: 'Conta',
    accounts: 'Contas',
    zone: 'Zona',
    zones: 'Zonas',
    relay: 'Relé',
    relays: 'Relés',
    enter_domain: 'Insira um domínio',
    hostnames: 'Nome de host',
    term_callout: 'Precisa de um comprimento de prazo mais longo?',
    select_term: 'Selecione seu termo',
    recommended: 'Recomendado',
    save: 'Salvar',
    includes: 'inclui',
    adjusting_preview: 'Ajustando a visualização',
    coupon_code_is_not_valid: 'O código do cupom não é válido.',
    contact_support_if_you_believe_this_is_an_error: 'Entre em contato com o suporte se acreditar que isso é um erro.',
    coupon_applied: 'Cupom Aplicado',
    sub_total: 'Subtotal',
    available_credit: 'Crédito disponível',
    credit_used: 'Crédito usado',
    coupon_code_will_be_applied_once_logged_in: 'O código do cupom será aplicado após o login.',
    monthly: 'Por mês',
    annually: 'Anualmente'
  },
  topnav: {
    planbuilder: 'Construtor de Plano',
    payment: 'Pagamento',
    orderconfirmation: 'Confirmação de Pedido'
  },
  plan_builder: {
    undo: 'Desfazer',
    item_removed: 'Um serviço foi removido do seu carrinho.',
    select_term: '<span class="text-semibold">Selecione um Prazo</span> para sua assinatura',
    years: 'anos',
    apply: 'Inscrever-se',
    total: 'Total',
    proceed_to_checkout: 'Continuar para Finalizar compra',
    removed_items: 'O(s) serviço(s) abaixo foram removidos de seu carrinho porque você já tem uma assinatura ativa para este(s) produto(s):',
    billing_management: 'Visite a página <a href="/redirect/mynoip?force=true&intended=account/billing-management" target="_blank">Gerenciamento de faturamento</a>  se desejar renová-los.',
    open_invoice: 'Você tem uma fatura em aberto para o(s) serviço(s) já em seu carrinho que foram removidos.',
    invoice_link: 'Vá para a página <a href="/redirect/mynoip?force=true&intended=account/billing-management" target="_blank">Gerenciamento de Faturamento</a>. e pague essas faturas para retomar seus serviços.',
    empty_cart: 'Seu carrinho está vazio',
    purchase_services: 'Confira todos os serviços que você pode adquirir na <a href="/"  class="text-info text-decoration-none">No-IP</a>',
    updated_enhanced_item: 'Atualmente, você tem <span class="text-semibold">{hostcount} nomes de host</span> e isso excede, <span class="text-semibold">{itemtitle} {itemoptionsquantity} Nome(s) de host</span>. Atualizamos seu carrinho para ir para a próxima assinatura disponível, <span class="text-semibold">{newitemtitle} {newitemoptionsquantity} Hostnames</span>.'
  },
  account: {
    create_an_account: 'Crie uma conta',
    have_an_account: 'Tenho uma conta',
    create_account: 'Criar conta',
    log_in: 'Entrar',
    email: 'E-mail',
    user_password: 'Senha',
    tos: "Eu concordo com os <a href='/legal/tos'>Termos do Serviço</a> e com a <a href='/legal/privacy'>Política de Privacidade</a>.",
    newsletter: 'Envie-me newsletters e ofertas especiais',
    login: 'Entrar',
    email_username: 'E-mail ou nome de usuário',
    forgotpassword: 'Esqueceu a senha?',
    login_continue: 'Entrar e continuar',
    auth_failure: 'A combinação de nome de usuário/senha está incorreta. Tente outra vez.',
    too_many_attempts: 'Seu endereço de IP enviou este formulário muitas vezes recentemente. Aguarde alguns minutos antes de tentar outra vez.',
    too_many_attempts: 'Sua conta foi bloqueada devido a um número excessivo de falhas ao inserir a senha. A conta será desbloqueada daqui a 15 minutos, quando você poderá tentar fazer login outra vez. Você pode ligar para 1-877-367-6647 durante o horário comercial: das 6h30 às 17h30, horário do Pacífico, de segunda a sexta-feira, para desbloquear sua conta imediatamente. Este é um recurso de segurança para prevenir tentativas de login por força bruta. Caso tenha esquecido sua senha, use o nosso formulário Esqueceu a Senha para receber um link de redefinição da senha. Então, tente fazer login novamente em 15 minutos.',
    captcha_failure: 'O reCAPTCHA falhou. Você precisará concluir o reCAPTCHA com sucesso para fazer login.',
    newsletter: 'Envie-me newsletters e ofertas especiais',
    create_account: 'Crear una cuenta',
    logged_in_as: 'Logado como',
    create_an_account: 'Precisa criar uma conta?',
    already_have_an_account: 'Já tem uma conta?',
    sign_up_with_google: 'Cadastre-se com o Google',
    sign_in_with_google: 'Entrar com o Google',
    sign_up_with_microsoft: 'Cadastre-se com o Microsoft',
    sign_in_with_microsoft: 'Entrar com o Microsoft'
  },
  domain_input: {
    tooltip: 'Insira um domínio que você possui para usar com esse serviço. Nota: isso não registrará o domínio.'
  },
  domain_reg: {
    tooltip: 'Registre seu domínio com o No-IP, registrar credenciado pelo ICANN.'
  },
  account_enhanced: {
    tooltip: 'Acesse remotamente um computador, dispositivo ou rede sem se preocupar sobre confirmações mensais de hostname.',
    hostnames: 'Hostnames'
  },
  support_priority: {
    tooltip: 'Um canal de atendimento com respostas prioritárias, formado pela nossa prestativa e experiente equipe de Suporte Técnico. Seu ticket ou chamado de suporte é colocado na frente da fila para que você receba ajuda quando mais precisar.'
  },
  dns_tier: {
    tooltip: 'DNS rápido e confiável para o seu domínio, respaldado pela nossa robusta rede Anycast com mais de 100 pontos de presença localizados ao redor do mundo.'
  },
  dns_squared: {
    tooltip: 'Maximize o tempo de atividade e aumente a confiabilidade usando sua atual infraestrutura de DNS.'
  },
  mail_backupmx: {
    tooltip: 'O Backup MX lhe oferece paz de espírito. Se o seu servidor de e-mails cair, você não perderá e-mails importantes.'
  },
  mail_reflector: {
    tooltip: 'Administre seu próprio servidor de e-mails, mesmo que o seu ISP bloqueie a porta 25'
  },
  mail_pop: {
    tooltip: 'O POP3/IMAP é a opção ideal para quem não quer ter a dor de cabeça de gerenciar seu próprio servidor de e-mails.'
  },
  mail_forwarding: {
    tooltip: 'O encaminhamento de e-mails permite que você receba mensagens em seu domínio e as encaminhe para uma conta existente.'
  },
  mail_smtp: {
    tooltip: 'O SMTP se destina aos administradores que têm a porta 25 bloqueada ou road warriors que não querem alterar as configurações de SMTP.'
  },
  ssl_rapid: {
    tooltip: 'Protege um único domínio com criptografia forte. É emitido dentro de minutos, ajudando você a desenvolver e lançar um site seguro rapidamente.'
  },
  ssl_rapid_dv: {
    tooltip: 'Protege um único domínio com criptografia forte. É emitido dentro de minutos, ajudando você a desenvolver e lançar um site seguro rapidamente.'
  },
  ssl_premium: {
    tooltip: 'Oferece procedimentos abrangentes de autenticação (verificação de nome de domínio e identidade) com alta garantia, tornando esse certificado perfeito para proteger seu domínio profissional.'
  },
  ssl_rapid_wildcard: {
    tooltip: 'Proteja subdomínios ilimitados com criptografia forte. Os certificados são emitidos dentro de minutos e são a maneira mais acessível de proteger múltiplos domínios.'
  },
  ssl_rapid_wildcard_dv: {
    tooltip: 'Proteja subdomínios ilimitados com criptografia forte. Os certificados são emitidos dentro de minutos e são a maneira mais acessível de proteger múltiplos domínios.'
  },
  ssl_trustcor_standard: {
    tooltip: 'Protege um único domínio com criptografia forte. É emitido dentro de minutos, ajudando você a desenvolver e lançar um site seguro rapidamente.'
  },
  ssl_trustcor_premium: {
    tooltip: 'Protege um único domínio com criptografia forte. É emitido dentro de minutos, ajudando você a desenvolver e lançar um site seguro rapidamente.'
  },
  ssl_trustcor_wildcard: {
    tooltip: 'Proteja subdomínios ilimitados com criptografia forte. Os certificados são emitidos dentro de minutos e são a maneira mais acessível de proteger múltiplos domínios.'
  },
  monitor_basic: {
    tooltip: 'O servidor cair é uma coisa, não saber do ocorrido é ainda pior. Seja alertado instantaneamente quando houver um problema.'
  },
  monitor_advanced: {
    tooltip: 'Monitoramento ininterrupto do servidor, incluindo failover automático. As configurações do seu DNS apontam automaticamente para o seu servidor de backup ou página personalizada, imediatamente.'
  },
  team_login: {
    tooltip: 'Team Login allows you to coordinate seamlessly with different logins affiliated with your account.'
  },
  registration_domain: {
    tooltip: 'Registre seu domínio com o No-IP, registrar credenciado pelo ICANN.',
    bundle_discount: 'Desconto no Pacote',
    you_saved: 'Você Economizou',
    hide_info: 'Sim, esconda minhas informações pessoais do mundo por',
    no_thanks: 'Não, obrigado',
    private_registration_no: 'Registro Privado - Não'
  },
  registration_transfer: {
    tooltip: 'Transfira seu domínio de outro registrar para o No-IP.'
  },
  registration_privacy: {
    tooltip: 'O Registro Privado mantém as informações de contato do seu domínio em sigilo. Configuramos um proxy que lida com spam e encaminha o que você precisa.',
    private_registration: 'Registro Privado'
  },
  host_redemption: {
    tooltip: 'Recupere seu hostname da Redenção e mantenha as mesmas configurações que você tinha antes da Redenção.'
  },
  dns_pro: {
    tooltip: 'Crie nomes de host em seu próprio domínio ou use um domínio de propriedade No-IP com DNS dinâmico de nível profissional que se adapta às suas necessidades.'
  },
  domain_contact: {
    contact: {
      oganization: 'Organização',
      email_address: 'E-mail',
      first_name: 'Nome',
      last_name: 'Sobrenome',
      address: 'Endereço',
      address2: 'Endereço 2',
      country: 'País',
      state_province: 'Estado / Província',
      city: 'Cidade',
      postal_zip: 'Código postal/CEP',
      phone_number: 'Telefone'
    },
    contact_form: {
      domain_contact: 'Contato de Domínio',
      domain_contact_text: 'O registro de domínio requer informações de contato de domínio válidas para ser registrado. Isso significa que seu nome e detalhes de contato pessoais estarão disponíveis publicamente no registro WHOIS. Se você adicionou Registro Privado, o registro exibirá nossas informações em vez das suas. Não se preocupe em perder alguma coisa, encaminharemos todas as coisas importantes para você.',
      add_private_reg: 'Adicionar registro privado agora',
      existing_domain_contact: 'Usar um Contato de Domínio existente',
      new_domain_conact: 'Criar um novo Contato de Domínio',
      verifying: 'Verificando',
      continue: 'Continuar',
      an_unexpected_error: "Desculpe, encontramos um erro inesperado, tente novamente em alguns minutos. Se o erro persistir, comunique-o em um <a href='/ticket'>tíquete de suporte</a> com seus detalhes de contato."
    },
    order_summary: {
      order_summary: 'Resumo do pedido',
      edit: 'Editar'
    }
  },
  upsell: {
    add_to_cart: 'adicionar ao carrinho',
    plus_description: 'DNS dinâmico totalmente personalizado, criando um nome de host fácil de lembrar em seu próprio domínio.',
    enhanced_description: 'Crie um nome de host fácil de lembrar para acessar seu dispositivo remotamente e nunca se preocupe em confirmar seu nome de host enquanto sua assinatura permanecer ativa.',
    priority_description: 'O suporte prioritário No-IP é um canal de suporte de resposta prioritária que conta com nossa equipe de suporte técnico amigável e experiente. O Suporte prioritário permite que você obtenha o suporte necessário o mais rápido possível.',
    rapid_description: 'Os certificados RapidSSL Basic DV protegem um único domínio com criptografia forte. É emitido em minutos, ajudando você a desenvolver e lançar um site seguro rapidamente. É uma maneira rápida e barata de proteger seu site.',
    rapid_wildcard_description: 'Os certificados RapidSSL Wildcard protegem subdomínios ilimitados com criptografia forte. Os certificados são emitidos em minutos e são a maneira mais econômica de proteger vários domínios.',
    team_login_description: 'O Login de Equipe permite que você convide membros adicionais da equipe para sua conta. Permita que os membros da sua equipe ajudem você a fazer mais com o gerenciamento de clientes, assinaturas e muito mais.',
    recommended: 'Recomendado',
    team_login_tooltip: 'Cada conta No-IP vem com um proprietário de conta. Precisa de outro login? Adicione um membro da equipe à sua conta.',
    per_team_member: 'por membro da equipe'
  }
};
